import { render, staticRenderFns } from "./FBGroupsPlatformIcon.vue?vue&type=template&id=3f7bd754&scoped=true"
import script from "./FBGroupsPlatformIcon.vue?vue&type=script&lang=js"
export * from "./FBGroupsPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7bd754",
  null
  
)

export default component.exports